import e from '@/lang/fr/error'

export default {
  contingent_contingent: {
    show: {
      page_title: 'Détails contingent'
    },
    edit: {
      page_title: 'Modification du contingent'
    },
    list: {
      page_title: 'Liste des contingents'
    },
    form: {
      750: e.error[750],
      755: e.error[755]
    }
  },
  hotel_contingent: {
    show: {
      page_title: 'Détails contingent'
    },
    edit: {
      page_title: 'Modification du contingent'
    },
    list: {
      page_title: 'Liste des contingents'
    },
    form: {
      750: e.error[750],
      755: e.error[755]
    }
  }
}
